import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

const Firebase = {
  install(Vue, config) {
    firebase.initializeApp(config);
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$database = firebase.database;
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$auth = firebase.auth;
  },
};

export default Firebase;



// WEBPACK FOOTER //
// ./src/plugins/firebase.js